module.exports = __webpack_public_path__ + "img/menu-board-mc-donald.8f152a61.webp";